import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.debounceTimer = null
  }

  search() {
    // Debounce the search to avoid too many DOM operations
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.performSearch()
    }, 150)
  }

  performSearch() {
    const query = this.inputTarget.value.toLowerCase().trim()

    // Find all task cards on the board
    const taskCards = document.querySelectorAll('[data-draggable-target="item"]')

    taskCards.forEach((card) => {
      // Get searchable text from the card (site name, task name, employee names)
      const siteName = card.querySelector(".text-xs.uppercase")?.textContent?.toLowerCase() || ""
      const taskName = card.querySelector("h3")?.textContent?.toLowerCase() || ""

      // Check if the card matches the search query
      const matches = query === "" || siteName.includes(query) || taskName.includes(query)

      // Show or hide the card
      if (matches) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  // Clear search when input is cleared
  clear() {
    this.inputTarget.value = ""
    this.performSearch()
  }
}
